<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <a class="decoration"> Maintainence Management </a>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Upload File
      </h6>

      <div style="padding-bottom: 100px;" class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="SaveProduct">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Pdf/ Excel</label>
                    <input type="file" @change="handleFileUpload" class="form-control bdr-rad" />
                  </div>
                </div>

             

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Number</label>
                    <input type="text" v-model="alldata.number" class="form-control bdr-rad" />
                  </div>
                </div>
              </div>

              <div class="navbar">
                <div class="d-flex"></div>
                <div class="d-flex">
                  <button type="submit" class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad">
                    Upload
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- ✅ Popup Modal -->
<!-- ✅ Popup Modal -->
<div v-if="showPopup" class="popup-overlay">
  <div class="popup-card">
    <!-- Fixed Header -->
    <div class="popup-header">
      <h5>Crop area to extract text</h5>
    </div>

    <!-- Scrollable Content -->
    <div class="popup-body">
      <!-- Show OCR editable box if result exists -->
      

      <!-- PDF Canvas -->
      <canvas v-show="!ocrText"
        ref="pdfCanvas"
        @mousedown="startSelection"
        @mousemove="drawSelection"
        @mouseup="endSelection"></canvas>
    </div>

    <!-- Fixed Footer -->
   <div class="popup-footer ">
  <!-- OCR Result input (left side) -->
  <div v-if="ocrText" class="mb-1">
    <!-- <label class="mb-1">OCR Result (editable):</label>
    <input type="text" v-model="ocrText" class="form-control" /> -->
    <label class="mb-1">Ref:</label>
    <input type="text" v-model="ocr_ref" class="form-control" disabled/>
    <label class="mb-1">Authorised Date</label>
    <input type="text" v-model="ocr_auth_date" class="form-control" />
  </div>

  <!-- Buttons (right side) -->
  <div class="">
    <button class="btn btn-sm btn-secondary mr-1" @click="closePopup">Cancel</button>
    <button v-if="!ocrText" class="btn btn-sm btn-primary" @click="runOcr">Save</button>
    <button v-else class="btn btn-sm btn-success " @click="confirmOcr">Confirm</button>
  </div>
</div>

  </div>
</div>



    <content-footer></content-footer>
  </div>
</template>

<script>
import Content from '@/layout/Content.vue'
     import axios from 'axios';
export default {
  components: { Content },
  data() {
    return {
      file: null,
      alldata: {},
      showPopup: false,
      pdfPage: null,
      selection: null,
      isSelecting: false,
      ocrText: "",
      ocr_auth_date: "",
      ocr_ref: "",
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    async SaveProduct() {
      if (!this.file) {
        alert("Please select a file first.");
        return;
      }

      if (this.file.type.includes("pdf")) {
        this.showPopup = true;
        await this.renderPDF(this.file);
      } else {
        alert("Only PDF supported for crop OCR here.");
      }
    },

   async renderPDF(file) {
  const reader = new FileReader();

  reader.onload = async (e) => {
    const typedarray = new Uint8Array(e.target.result);
    const pdf = await window.pdfjsLib.getDocument({ data: typedarray }).promise;

    // get FIRST page only
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 2 });

    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    canvas.style.border = "1px solid #ccc";

    const ctx = canvas.getContext("2d");

    await page.render({
      canvasContext: ctx,
      viewport: viewport,
    }).promise;

    // clear popup body
    const popupBody = this.$el.querySelector(".popup-body");
    popupBody.innerHTML = "";
    popupBody.appendChild(canvas);

    // save reference
    this.firstPageCanvas = canvas;
  };

  reader.readAsArrayBuffer(file);
},

    // --- Selection helpers ---
    startSelection(e, canvas, bufferCanvas) {
      this.isSelecting = true;
      const rect = canvas.getBoundingClientRect();
      this.selection = {
        canvas,
        bufferCanvas,
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
        w: 0,
        h: 0,
      };
    },

    drawSelection(e, canvas, bufferCanvas) {
      if (!this.isSelecting || !this.selection) return;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      this.selection.w = x - this.selection.x;
      this.selection.h = y - this.selection.y;

      // redraw from buffer
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(bufferCanvas, 0, 0);

      // draw selection rectangle
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      // draw rect with support for negative w/h (dragging left/up)
      const sx = this.selection.w < 0 ? this.selection.x + this.selection.w : this.selection.x;
      const sy = this.selection.h < 0 ? this.selection.y + this.selection.h : this.selection.y;
      const sw = Math.abs(this.selection.w);
      const sh = Math.abs(this.selection.h);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

    endSelection(e, canvas, bufferCanvas) {
      if (!this.selection) return;
      this.isSelecting = false;

      // normalize selection coordinates (so width/height are positive)
      let { x, y, w, h } = this.selection;
      const sx = w < 0 ? x + w : x;
      const sy = h < 0 ? y + h : y;
      const sw = Math.abs(w);
      const sh = Math.abs(h);

      // small area guard
      if (sw < 5 || sh < 5) {
        this.selection = null;
        // redraw full page without box
        const ctx = canvas.getContext("2d");
        ctx.drawImage(bufferCanvas, 0, 0);
        return;
      }

      this.selection = { canvas, bufferCanvas, x: sx, y: sy, w: sw, h: sh };

      // final draw of rectangle
      const ctx = canvas.getContext("2d");
      ctx.drawImage(bufferCanvas, 0, 0);
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

    // --- OCR pipeline ---
async runOcr() {
  if (!this.firstPageCanvas) {
    alert("PDF not loaded");
    return;
  }

  this.firstPageCanvas.toBlob(async (blob) => {
    let formData = new FormData();
    formData.append("file", blob, "page1.png");

    try {
      const response = await axios.post(
        "/mproduct/scan",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(response.data);
      this.ocrText = response.data.ocr_text || "";
      this.ocr_ref = response.data.ocr_ref || "";
      this.ocr_auth_date = response.data.ocr_auth_date || "";

    } catch (error) {
      console.log("===== OCR ERROR =====");

      if (error.response) {
        console.log("Status:", error.response.status);
        console.log("Backend error:", error.response.data);
        alert("Backend Error: " + JSON.stringify(error.response.data));
      } else {
        alert(error.message);
      }
    }
  }, "image/png");
},



    confirmOcr() {
      this.alldata.number = this.ocrText;
      this.showPopup = false;
      this.ocrText = "";
      this.selection = null;
    },

    closePopup() {
      this.showPopup = false;
      this.selection = null;
      this.ocrText = "";
    },

    // --- Image processing helpers (simple, pure JS) ---
   
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-card {
  background: #fff;
  width: 80%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}
canvas {
  border: 1px solid #ccc;
  cursor: crosshair;
}

.popup-header {
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;
  padding: 10px;
}


/* Scrollable middle section */
.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

/* Fixed footer */
.popup-footer {
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  width: 500px;
  align-items: center;
  justify-content: space-between; /* OCR input left, buttons right */
}
.ocr-box {
  flex: 1;
  margin-right: 15px;
}
</style>
